"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeesTab = exports.Payers = void 0;
const core_1 = require("@material-ui/core");
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const select_1 = require("client/components/material/select");
const text_field_1 = require("client/components/material/text-field");
const text_field_small_1 = require("client/components/material/text-field/text-field-small");
const menu_1 = require("client/components/menu");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/sites/modules/sites-list/store");
const store_2 = require("client/modules/users/store");
const store_3 = require("../../../../../client/modules/sites/modules/sites-detail/store");
const router_1 = require("../../../../../client/components/router");
const store_4 = require("../../../../../client/modules/patients/store");
const Delete_1 = require("material-ui-icons/Delete");
const Button_1 = require("material-ui/Button");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const ReactTooltip = require("react-tooltip");
const eob_1 = require("shared/eob");
const confirmation_modal_1 = require("client/components/confirmation-modal");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const throttle_debounce_1 = require("throttle-debounce");
const store_5 = require("../../store");
const eob_history_1 = require("../eob-history");
require("./eob-fees.less");
const modal_1 = require("../../../../../client/components/modal");
const asset_list_1 = require("../../../../../client/components/asset-list");
const upload_modal_1 = require("../../../../../client/components/upload-modal");
const asset_list_overview_1 = require("../../../../../client/components/asset-list-overview"); // E-067.1
const moment = require("moment"); // E-067.1
const iframe_preview_1 = require("../../../../../client/modules/inventory-order/tabs/order-review/components/iframe-preview"); // E-067.1
const Edit_1 = require("@material-ui/icons/Edit"); // E-067.1
const AttachFile_1 = require("@material-ui/icons/AttachFile"); // E-067.1
const dummyHeader = {
    pharmacy: "",
    checkNumber: "",
    checkTotal: null,
    source: eob_1.EobSource.claim,
    dirFee: null,
    eobDate: new Date(),
    eobTotal: null,
    interestPayment: null,
    payer: "",
    posFee: null,
    uploads: [],
};
const dummyDetail = {
    amountPaid: null,
    awp: null,
    dateOfService: new Date(),
    rxNumber: null || "",
    autoReverse: false,
    claimId: null,
    drugName: "",
    posFees: null,
    dirFees: null,
    insReimb: null,
    claimStatus: "",
};
/** List of known payers requiring templates */
var Payers;
(function (Payers) {
    Payers["default"] = "Default Fields";
    Payers["esi"] = "Express Scripts";
    Payers["opt"] = "OptumRx";
    Payers["dst"] = "DST Health";
    Payers["mag"] = "Magellan Rx";
})(Payers = exports.Payers || (exports.Payers = {}));
let FeesTab = class FeesTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.payerFilterText = "";
        this.claimFilterText = "";
        this.claimId = null;
        this.confirmSubmission = false;
        this.reConfirmSubmission = false;
        this.confirmDuplicate = false;
        this.shouldProcess = false;
        // not needed : added drug name to eobDetail
        // @observable
        // public drugNameDesc: string = "";
        this.displayEobTotal = "0.00";
        this.prevHeaderPosFee = 0;
        this.prevHeaderDirFee = 0;
        this.selectedHeaderInitialEobTotal = 0;
        // wip - decimals (display observables below)
        // @observable
        // public displayCheckTotal: string = "";
        // @observable
        // public displayAmountPaid: string = "";
        // @observable
        // public displayPosFees: string = "";
        // @observable
        // public displayDirFees: string = "";
        this.claimBinNum = "";
        this.claimPcn = "";
        this.claimGroupId = "";
        this.buttonSaved = false;
        this.rxNeedFocus = false;
        this.rxRowNeedFocus = [false];
        this.rxRowNeedFocusTrue = [];
        this.showMenu = false;
        this.showMenuPayers = false;
        this.showMenuClaims = false;
        this.showDetail = false;
        this.loading = false;
        this.quickSearchSelection = null;
        this.quickSearchSelectionClaims = null;
        this.quickSearchSelectionPayers = null;
        this.eobSiteId = 0; // so IMB users can select pharmacy to make eob.
        this.currentUserId = 0; // so IMB users can be recorded in ledger when entering eob details.
        this.siteImbFee = 0; // to get the IMB fee for the selected pharmacy to update ledger.
        this.headerId = 0; // so IMB users can select pharmacy to make eob.
        this.RxNum = 0; // so IMB users can select claim.
        this.eobHeader = dummyHeader;
        this.eobDetail = dummyDetail;
        this.eobUploads = []; //E-067
        this.isEobUploads = false; //E-067
        this.claimEobDetail = [];
        this.selectedHeaderEobDetail = [];
        this.selectedPayerTemplate = Payers.default;
        this.assetModal = false; //E-067
        this.uploadModal = false; //E-067
        this.iframeUrl = ""; //E-067.1
        this.eobListView = []; //E-067.1
        this.loadClaims = throttle_debounce_1.debounce(200, (showLoading) => {
            const query = {
                siteId: this.eobSiteId,
                count: 100,
                search: this.claimFilterText,
                start: 0,
            };
            const result = store_5.eobStore.loadClaims(query, showLoading);
            // console.log("load claims result query passed", query);
        });
        this.loadPayers = async () => {
            const query = { siteId: this.eobSiteId };
            await store_5.eobStore.loadPayers();
        };
        // E-067
        this.isAttachDocs = false;
        this.handleDocsClicked = () => {
            this.assetModal = !this.assetModal;
            this.isAttachDocs = !this.isAttachDocs;
        };
        this.onCredentialUpload = () => {
            this.uploadType = "credential";
            this.uploadModal = true;
        };
        this.assetModalCancel = () => {
            this.assetModal = !this.assetModal;
            this.isAttachDocs = !this.isAttachDocs;
        };
        this.handleClickCancelUpload = () => {
            this.uploadModal = false;
        };
        this.handleAssetsUpload = async (accepted) => {
            var _a, _b;
            await store_3.sitesDetailStore.upload(accepted, String((_a = store_5.eobStore.eobSelected) === null || _a === void 0 ? void 0 : _a.id), this.uploadType, "Eob");
            const result = await store_5.eobStore.readEob({ eobId: (_b = store_5.eobStore.eobSelected) === null || _b === void 0 ? void 0 : _b.id });
            if (result.success) {
                this.isEobUploads = true;
                this.eobUploads = result.eob.uploads;
            }
            router_1.RouteManager.transitionTo(`/eob/eobfees`);
        };
        this.onImageUpload = () => {
            this.uploadType = "image";
            this.uploadModal = true;
        };
        this.onDeleteAsset = async (uploadId) => {
            var _a;
            await store_3.sitesDetailStore.deleteUpload(uploadId);
            const result = await store_5.eobStore.readEob({ eobId: (_a = store_5.eobStore.eobSelected) === null || _a === void 0 ? void 0 : _a.id });
            if (result.success) {
                this.isEobUploads = true;
                this.eobUploads = result.eob.uploads;
            }
        };
        this.handleAssetsDescriptionsSave = async (uploads) => {
            await store_4.patientsStore.updateAssetsDescriptions(uploads);
        };
        this.handleAssetsExpDateSave = async (uploads) => {
            await store_4.patientsStore.updateAssetsExpDate(uploads);
        };
        // End E-067
        this.handleEobSelect = () => {
            console.log("cwm eobselected is ", store_5.eobStore.eobSelected);
            if (store_5.eobStore.eobSelected) {
                this.initializeEob();
            }
        };
        this.payerOptions = () => {
            const options = [
                Payers.default,
                Payers.dst,
                Payers.esi,
                Payers.mag,
                Payers.opt,
            ];
            const selections = options.map((payer, i) => ({
                id: i,
                label: payer,
                value: payer,
            }));
            return selections;
        };
        this.initializeEob = () => {
            const { eobSelected } = store_5.eobStore;
            if (eobSelected) {
                const { checkNumber, checkTotal, eobDate, site, payer, pharmacy, detail, eobTotal, interestPayment, posFee, dirFee, source, } = eobSelected;
                this.eobHeader.source = pharmacy;
                this.eobHeader.pharmacy = pharmacy;
                this.payerFilterText = payer;
                this.eobHeader.payer = this.payerFilterText;
                this.eobHeader.eobDate = eobDate;
                this.eobSiteId = site.id;
                this.eobHeader.checkTotal = checkTotal;
                this.eobHeader.interestPayment = interestPayment || "0.00";
                this.eobHeader.posFee = posFee || "0.00";
                this.prevHeaderPosFee = Number(posFee) || 0;
                this.eobHeader.dirFee = dirFee || "0.00";
                this.prevHeaderDirFee = Number(dirFee) || 0;
                this.eobHeader.checkNumber = checkNumber;
                this.displayEobTotal = eobTotal.toFixed(2);
                this.selectedHeaderInitialEobTotal = eobTotal;
                this.eobHeader.eobTotal = this.selectedHeaderInitialEobTotal;
                this.selectedHeaderEobDetail = detail;
                this.showDetail = true;
                // this.claimEobDetail = detail;
            }
        };
        this.resetHeader = () => {
            this.payerFilterText = "";
            this.eobHeader = dummyHeader;
            this.displayEobTotal = "";
            this.prevHeaderPosFee = 0;
            this.prevHeaderDirFee = 0;
        };
        this.resetDetail = () => {
            this.claimFilterText = "";
            this.claimId = null;
            this.eobHeader.source = false;
            this.displayEobTotal = "0.00";
            this.eobDetail = dummyDetail;
            this.claimBinNum = "";
            this.claimGroupId = "";
            this.claimPcn = "";
            this.claimEobDetail = [];
        };
        this.handleViewEobHistory = () => {
            var _a;
            if (this.eobListView || ((_a = this.eobListView) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                this.eobListView = []; // E-067.1
            }
            store_5.eobStore.showHistory = true;
            this.showDetail = false;
            this.buttonSaved = false;
            store_5.eobStore.eobSelected = null;
            this.eobSiteId = store_2.usersStore.user.value.site.id;
            this.resetHeader();
            this.resetDetail();
        };
        // E-067.1
        this.eob_class = {
            display: "flex",
        };
        // E-067.1
        this.handlePreviewClose = () => {
            this.iframeUrl = "";
            this.currentAssetViewing = null;
        };
        // E-067.1
        this.renderEOBAssetListRow = () => { var _a; return (_a = this.eobListView) === null || _a === void 0 ? void 0 : _a.sort((a, b) => moment(a.expDate) < moment(b.expDate) ? 1 : -1).map((upload, index) => {
            let expdate = "";
            if (upload.expDate) {
                expdate = moment(upload.expDate).format("MM/DD/YYYY");
            }
            return (React.createElement("li", { "data-tip": `${upload.fileOriginalName} ${upload.description ? " (" + upload.description + ")" : ""}
                      `, onClick: () => {
                    this.iframeUrl = upload.filePath;
                    this.currentAssetViewing = upload;
                }, key: index, className: "list" },
                React.createElement("div", { className: "list-expdate__name" }, upload.description || upload.fileOriginalName),
                React.createElement("div", { className: "list-expdate__date" }, expdate ? ` ${expdate}` : "")));
        }); };
        // E-067.1 end
        this.renderEobHeader = () => {
            var _a, _b, _c;
            return (React.createElement("div", { className: "eob__header" },
                React.createElement("div", { className: "edit-eob-header" },
                    React.createElement(ui_1.UiForm, { buttons: [
                            React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel, disabled: !!store_5.eobStore.eobSelected }, "Clear"),
                            // "Save Header"
                            "Add Details",
                        ], onSubmit: this.handleSave, className: "eob-header-form", loading: false, status: ui_1.FormStatus.Dirty, shouldDisableSave: this.showDetail, saved: "Saved", error: this.props.error },
                        React.createElement("div", { className: "eob-header-form__headline" },
                            React.createElement(core_1.Typography, { variant: "headline", gutterBottom: true }, store_5.eobStore.eobSelected
                                ? `Viewing EOB ${store_5.eobStore.eobSelected.id}`
                                : "New EOB Entry"),
                            React.createElement(button_1.MaterialButton, { onClick: this.handleViewEobHistory }, "View EOB History")),
                        React.createElement("div", { className: "row" },
                            React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, searchable: true, disabled: !!store_5.eobStore.eobSelected, label: "Pharmacy", onSelect: this.handleChangeSite, value: String(this.eobSiteId) || "" }),
                            React.createElement("span", { style: { display: "flex" } },
                                React.createElement(menu_1.Menu, { data: this.availablePayers(), showMenu: this.showMenuPayers, onAction: this.handleOnMenuActionPayers },
                                    React.createElement(text_field_1.MaterialTextField, { className: "payer", required: true, label: "Payer Name", disabled: !!store_5.eobStore.eobSelected, onChange: this.handlePayerSearch(), value: this.payerFilterText, onBlur: () => (this.showMenuPayers = false) })),
                                React.createElement(select_1.MaterialSelect, { options: this.payerOptions(), value: this.selectedPayerTemplate, required: true, label: "Entry Template", onSelect: (v) => {
                                        this.selectedPayerTemplate = v;
                                    } }))),
                        React.createElement("div", { className: "row" },
                            React.createElement(date_picker_1.MaterialDatePicker, { className: "eob-date", label: "Check Date *", missing: this.missing.eobDate, disabled: !!store_5.eobStore.eobSelected, onChange: this.handleChangeEobDate, value: this.eobHeader.eobDate || "" }),
                            React.createElement(select_1.MaterialSelect, { options: [
                                    { id: 1, label: "Claim", value: eob_1.EobSource.claim },
                                    { id: 2, label: "Copay", value: eob_1.EobSource.copay },
                                ], value: this.eobHeader.source, disabled: !!store_5.eobStore.eobSelected, required: true, label: "Financial Source", onSelect: (v) => {
                                    this.eobHeader.source = v;
                                } })),
                        React.createElement("div", { className: "row viewassets-input" },
                            React.createElement(text_field_1.MaterialTextField, { className: "interest-payment", required: true, disabled: !!store_5.eobStore.eobSelected, label: "Interest Payment", 
                                // type="number"
                                // numType="decimal"
                                // inputProps={{ step: "0.01" }}
                                missing: this.missing.interestPayment, onChange: this.handleChangeString("interestPayment"), value: this.eobHeader.interestPayment || "" }),
                            React.createElement(text_field_1.MaterialTextField, { className: "posfee", required: true, label: "POS Fee", disabled: !!store_5.eobStore.eobSelected, missing: this.missing.posFee, onChange: this.handleChangeString("posFee"), value: this.eobHeader.posFee || "", onBlur: () => {
                                    this.eobHeader.eobTotal +=
                                        this.prevHeaderPosFee - Number(this.eobHeader.posFee);
                                    this.displayEobTotal = this.eobHeader.eobTotal.toFixed(2);
                                    this.prevHeaderPosFee = Number(this.eobHeader.posFee);
                                    this.selectedHeaderInitialEobTotal =
                                        -Number(this.eobHeader.posFee) -
                                            Number(this.eobHeader.dirFee);
                                } }),
                            React.createElement(text_field_1.MaterialTextField, { className: "dirfee", required: true, label: "DIR Fee", disabled: !!store_5.eobStore.eobSelected, missing: this.missing.dirFee, onChange: this.handleChangeString("dirFee"), value: this.eobHeader.dirFee || "", onBlur: () => {
                                    this.eobHeader.eobTotal +=
                                        this.prevHeaderDirFee - Number(this.eobHeader.dirFee);
                                    this.displayEobTotal = this.eobHeader.eobTotal.toFixed(2);
                                    this.prevHeaderDirFee = Number(this.eobHeader.dirFee);
                                    this.selectedHeaderInitialEobTotal =
                                        -Number(this.eobHeader.posFee) -
                                            Number(this.eobHeader.dirFee);
                                } })),
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { className: "check-amount", required: true, disabled: !!store_5.eobStore.eobSelected, label: "Check Amount", missing: this.missing.checkAmount, onChange: this.handleChangeString("checkTotal"), value: this.eobHeader.checkTotal || "" }),
                            React.createElement(text_field_1.MaterialTextField, { className: "check-number", required: true, label: "Check Number", disabled: !!store_5.eobStore.eobSelected, missing: this.missing.checkNum, onChange: this.handleChangeString("checkNumber"), value: this.eobHeader.checkNumber || "" }),
                            React.createElement(text_field_1.MaterialTextField, { className: "eob-total", label: "EOB Total", value: this.displayEobTotal || "0.00" })),
                        ((_a = store_5.eobStore.eobSelected) === null || _a === void 0 ? void 0 : _a.id) && (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "view-assets" },
                                React.createElement("div", null,
                                    React.createElement(asset_list_overview_1.AssetListOverview, { btnLabel: ((_b = this.eobListView) === null || _b === void 0 ? void 0 : _b.length) ? React.createElement(React.Fragment, null,
                                            React.createElement(React.Fragment, null,
                                                React.createElement(Edit_1.default, null),
                                                " \u00A0 Edit Asset"))
                                            : React.createElement(React.Fragment, null,
                                                " ",
                                                React.createElement(AttachFile_1.default, null),
                                                " \u00A0 Attach Document"), onClick: this.handleDocsClicked }, this.renderEOBAssetListRow()))))),
                        this.assetModal && (React.createElement(modal_1.AssetModal, { title: `Attach Document`, width: "unset", maxWidth: "50%", maxHeight: "70%", top: "300px", onCancel: this.assetModalCancel },
                            React.createElement(asset_list_1.AssetList, { uploads: this.isEobUploads
                                    ? this.eobUploads
                                    : (_c = store_5.eobStore === null || store_5.eobStore === void 0 ? void 0 : store_5.eobStore.eobSelected) === null || _c === void 0 ? void 0 : _c.uploads, entityType: "eob", entityData: store_5.eobStore.eobSelected, onCredentialUpload: this.onCredentialUpload, onDeleteUpload: this.onDeleteAsset, onImageUpload: this.onImageUpload, onDescriptionSave: this.handleAssetsDescriptionsSave, onExpDateSave: this.handleAssetsExpDateSave, onConnectAssetSave: this.handleAssetsDescriptionsSave, isAttachDocs: this.isAttachDocs, onCancel: this.assetModalCancel }))),
                        this.uploadModal && (React.createElement(upload_modal_1.UploadModal, { onCancel: this.handleClickCancelUpload, message: "Please select", title: "Upload Asset", onDrop: this.handleAssetsUpload }))),
                    this.iframeUrl ? (React.createElement(iframe_preview_1.IFramePreview, { title: this.currentAssetViewing.fileOriginalName || "N/A", iframeUrl: this.iframeUrl, download: this.iframeUrl, onClose: this.handlePreviewClose })) : null,
                    React.createElement("br", null))));
        };
        this.renderEobDetail = () => {
            const dateOS = (React.createElement(date_picker_1.MaterialDatePicker, { className: "claim-date", label: "Date of Service *", onChange: this.handleChangeEobDate, value: this.eobDetail.dateOfService || "" }));
            const drugName = (React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "desc", label: "Drug Name", value: this.eobDetail.drugName || "" }));
            const insReimb = (React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "ins-reimb", label: "Insurance Reimb", value: this.eobDetail.insReimb || "" }));
            const claimStatus = (React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "claim-status", label: "Claim Status", value: this.eobDetail.claimStatus || "" }));
            const rxNum = (React.createElement(menu_1.Menu, { data: this.availableClaims(), showMenu: this.showMenuClaims, onAction: this.handleOnMenuActionClaims, className: "claims-menu" },
                React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "rx-num", label: "Search RX # *", autoFocus: true, error: this.rxNeedFocus, onChange: this.handleClaimSearch(), value: this.claimFilterText, onBlur: this.onBlurClaims })));
            const amtPaid = (React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "amount-paid", label: "Amount Paid *", onChange: this.handleChangeStringFees("amountPaid"), value: this.eobDetail.amountPaid || "" }));
            const posFees = (React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "pos-fees", label: "POS Fees *", onChange: this.handleChangeStringFees("posFees"), value: this.eobDetail.posFees || "" }));
            const dirFees = (React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "dir-fees", label: "DIR Fees *", onChange: this.handleChangeStringFees("dirFees"), value: this.eobDetail.dirFees || "" }));
            const autoRev = (React.createElement(checkbox_1.MaterialCheckbox, { onAction: () => this.handleCheck(), checked: this.eobDetail.autoReverse, className: "reversal-toggle", label: "Auto Reverse", onBlur: () => {
                    if (this.eobDetail.rxNumber &&
                        this.eobDetail.amountPaid &&
                        this.eobDetail.posFees &&
                        this.eobDetail.dirFees) {
                        this.eobHeader.eobTotal +=
                            Number(this.eobDetail.amountPaid) -
                                Number(this.eobDetail.posFees) -
                                Number(this.eobDetail.dirFees);
                        this.displayEobTotal = this.eobHeader.eobTotal.toFixed(2);
                        this.claimEobDetail.unshift(Object.assign(Object.assign({}, this.eobDetail), { bin: this.claimBinNum, pcn: this.claimPcn, groupId: this.claimGroupId }));
                        this.eobDetail = dummyDetail;
                        this.claimFilterText = "";
                        this.claimId = null;
                        this.claimBinNum = "";
                        this.claimGroupId = "";
                        this.claimPcn = "";
                        if (this.rxNeedFocus) {
                            this.rxRowNeedFocus.unshift(true);
                            this.rxRowNeedFocusTrue.push(true);
                        }
                        else {
                            this.rxRowNeedFocus.unshift(false);
                        }
                        this.rxNeedFocus = false;
                    }
                    else {
                        alert("Please fill out all required (*) fields");
                    }
                } }));
            const fields = {
                amtPaid,
                autoRev,
                claimStatus,
                dateOS,
                dirFees,
                drugName,
                insReimb,
                posFees,
                rxNum,
            };
            const dataFields = this.orderFields(fields);
            return (React.createElement("div", { className: "eob__detail" },
                React.createElement("div", { className: "edit-eob-detail" },
                    React.createElement(ui_1.UiForm, { buttons: [
                            React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
                            "Process EOB",
                        ], className: "eob-detail-form", onSubmit: this.handleSubmit, loading: this.loading, status: ui_1.FormStatus.Dirty, shouldDisableSave: this.buttonSaved ||
                            !!this.rxRowNeedFocusTrue.length ||
                            this.rxNeedFocus, saved: "Saved", error: this.props.error },
                        React.createElement("div", { className: "row" }, dataFields),
                        this.claimEobDetail.map((eobDetail, index) => this.renderNewRow(eobDetail, index)),
                        this.confirmSubmission && this.renderConfirmationModal(),
                        this.reConfirmSubmission && this.renderReConfirmationModal(),
                        this.confirmDuplicate && this.renderReConfirmationModal())),
                store_5.eobStore.eobSelected && (React.createElement("div", { className: "edit-eob-detail" }, this.selectedHeaderEobDetail.map((eobDetail, index) => this.renderDetailHistory(eobDetail, index))))));
        };
        this.orderFields = (elements) => {
            const { rxNum, amtPaid, posFees, dirFees, autoRev, dateOS, drugName, insReimb, claimStatus, } = elements;
            let dataFields;
            switch (this.selectedPayerTemplate) {
                case Payers.dst:
                    dataFields = [
                        rxNum,
                        dateOS,
                        posFees,
                        amtPaid,
                        dirFees,
                        autoRev,
                        drugName,
                        insReimb,
                        claimStatus,
                    ];
                    break;
                case Payers.esi:
                    dataFields = [
                        dateOS,
                        rxNum,
                        drugName,
                        amtPaid,
                        posFees,
                        dirFees,
                        autoRev,
                        insReimb,
                        claimStatus,
                    ];
                    break;
                case Payers.mag:
                    dataFields = [
                        rxNum,
                        dateOS,
                        drugName,
                        amtPaid,
                        posFees,
                        dirFees,
                        autoRev,
                        insReimb,
                        claimStatus,
                    ];
                    break;
                case Payers.opt:
                    dataFields = [
                        rxNum,
                        dateOS,
                        posFees,
                        dirFees,
                        amtPaid,
                        autoRev,
                        drugName,
                        insReimb,
                        claimStatus,
                    ];
                    break;
                default:
                    dataFields = [
                        rxNum,
                        amtPaid,
                        posFees,
                        dirFees,
                        autoRev,
                        dateOS,
                        drugName,
                        insReimb,
                        claimStatus,
                    ];
                    break;
            }
            return dataFields;
        };
        this.renderNewRow = (eobDetail, index) => {
            const posLabel = [Payers.dst, Payers.mag, Payers.opt].includes(this.selectedPayerTemplate)
                ? "Dispense Fees"
                : "POS Fees";
            const amtPaid = (React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "amount-paid", label: "Amount Paid *", onChange: this.handleChangeAddedAmount("amountPaid", eobDetail, index), value: eobDetail.amountPaid || "" }));
            const dirFees = (React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "dir-fees", label: "DIR Fees", onChange: this.handleChangeAddedFees("dirFees", eobDetail, index), value: eobDetail.dirFees || "" }));
            const posFees = (React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "pos-fees", label: posLabel, onChange: this.handleChangeAddedFees("posFees", eobDetail, index), value: eobDetail.posFees || "" }));
            const rxNum = (React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "rx-num", label: "RX #", error: this.rxRowNeedFocus[index] === true, value: eobDetail.rxNumber }));
            const autoRev = (React.createElement(checkbox_1.MaterialCheckbox, { onAction: () => this.handleCheckRow(eobDetail, index), checked: eobDetail.autoReverse, className: "reversal-toggle", label: "Auto Reverse" }));
            const dateOS = (React.createElement(date_picker_1.MaterialDatePicker, { className: "claim-date", label: "Date of Service", value: eobDetail.dateOfService }));
            const drugName = (React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "desc", label: "Drug Name", error: this.rxRowNeedFocus[index] === true, value: eobDetail.drugName || "" }));
            const insReimb = (React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "ins-reimb", label: "Insurance Reimb", error: this.rxRowNeedFocus[index] === true, value: eobDetail.insReimb || "0.00" }));
            const claimStatus = (React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "claim-status", label: "Claim Status", value: eobDetail.claimStatus || "" }));
            const fields = {
                amtPaid,
                autoRev,
                claimStatus,
                dateOS,
                dirFees,
                drugName,
                insReimb,
                posFees,
                rxNum,
            };
            const dataFields = this.orderFields(fields);
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "row", key: index },
                    dataFields,
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement(React.Fragment, null,
                            React.createElement(Button_1.default, { "data-tip": "Delete submission", className: "edit-group__remove-button", onClick: this.handleDeleteRow(index), color: "default" },
                                React.createElement(Delete_1.default, null))) }))));
        };
        this.renderDetailHistory = (eobDetail, index) => (React.createElement("div", { className: "row", key: index },
            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "rx-num", label: "RX #", disabled: true, value: eobDetail.rxNumber }),
            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "amount-paid", label: "Amount Paid", disabled: true, value: eobDetail.amountPaid || "0.00" }),
            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "pos-fees", label: "POS Fees", disabled: true, value: eobDetail.posFees || "0.00" }),
            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "dir-fees", disabled: true, label: "DIR Fees", value: eobDetail.dirFees || "0.00" }),
            React.createElement(date_picker_1.MaterialDatePicker, { className: "claim-date", label: "Date of Service", disabled: true, value: eobDetail.dateOfService }),
            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "desc", label: "Drug Name", disabled: true, value: eobDetail.drugName || "" })));
        this.handleDeleteRow = (submissionId) => async (e) => {
            // console.log("about to delete index", submissionId);
            // console.log("e", e);
            e.preventDefault();
            e.stopPropagation();
            // console.log("e.isPropagationStop", e.isPropagationStopped());
            const rowToDelete = [submissionId];
            if (rowToDelete.length) {
                const amountToDelete = this.claimEobDetail[submissionId].amountPaid -
                    this.claimEobDetail[submissionId].posFees -
                    this.claimEobDetail[submissionId].dirFees;
                this.eobHeader.eobTotal -= amountToDelete;
                this.displayEobTotal = this.eobHeader.eobTotal.toFixed(2);
                this.claimEobDetail.splice(submissionId, 1);
                this.rxRowNeedFocus.splice(submissionId, 1);
                this.rxRowNeedFocusTrue.splice(0, 1);
                // console.log("array with only true", this.rxRowNeedFocusTrue);
            }
        };
        this.renderConfirmationModal = () => this.confirmSubmission && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm", cancelText: "Go Back", message: `You are about to submit a duplicate ledger transaction for one or more RX numbers.
          You have entered the same RX number(s) in more than one details, while having checked
          the "Auto Reverse" box for at least one of those details.<br /><br /> The 
          "Auto Reverse" box means that the detail that has it checked will automatically insert 
          the fees in the ledger twice: once as a debit and once as a credit to reverse the first entry.  
          Thus, the other detail row(s) using the same RX number will lead to a duplicate ledger entry
          for that specific RX number, if processed. Are you sure you want to proceed?<br /><br />
          Click "Go Back" if you want to modify the details before processing, or click "Confirm"
          if you want to process the current EOB details.<br /><br />`, onCancel: this.onClickCancelConfirmModal, onConfirm: this.onClickConfirmModal, title: "Confirm Duplicate EOB Processing" }));
        this.renderReConfirmationModal = () => (this.reConfirmSubmission || this.confirmDuplicate) && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm", cancelText: "Go Back", message: `You are about to submit a duplicate ledger transaction for one or more RX numbers.
          Are you sure you want to proceed?<br /><br />
          Click "Go Back" if you want to modify the details before processing, or click "Confirm"
          if you want to process the current EOB details.<br /><br />`, onCancel: this.onClickCancelConfirmModal, onConfirm: this.onClickReConfirmModal, title: "Confirm Duplicate EOB Processing" }));
        this.renderEntry = () => (React.createElement(React.Fragment, null,
            this.renderEobHeader(),
            React.createElement("br", null),
            this.showDetail ? this.renderEobDetail() : ""));
        this.onClickCancelConfirmModal = () => {
            this.confirmSubmission = false;
            this.reConfirmSubmission = false;
            this.confirmDuplicate = false;
        };
        this.onClickConfirmModal = () => {
            this.confirmSubmission = false;
            this.reConfirmSubmission = true;
        };
        this.onClickReConfirmModal = () => {
            this.reConfirmSubmission = false;
            this.confirmDuplicate = false;
            this.shouldProcess = true;
            this.handleSubmit();
        };
        this.handleCancel = () => {
            if (store_5.eobStore.eobSelected) {
                this.resetDetail();
                this.displayEobTotal = this.selectedHeaderInitialEobTotal.toFixed(2);
            }
            else {
                this.eobHeader = dummyHeader;
                this.eobDetail = dummyDetail;
                this.payerFilterText = "";
                this.claimFilterText = "";
                this.claimId = null;
                this.displayEobTotal = "0.00";
                this.prevHeaderPosFee = 0;
                this.prevHeaderDirFee = 0;
                // this.drugNameDesc = "";
                this.claimBinNum = "";
                this.claimGroupId = "";
                this.claimPcn = "";
                this.showDetail = false;
                this.claimEobDetail = [];
                this.buttonSaved = false;
            }
        };
        this.handleSave = async () => {
            var _a;
            this.missing = {
                sites: false,
                payer: false,
                eobDate: false,
                checkAmount: false,
                checkNum: false,
                interestPayment: false,
                posFee: false,
                dirFee: false,
            };
            this.eobHeader.pharmacy = (_a = this.activeSite.displayName) !== null && _a !== void 0 ? _a : this.activeSite.name;
            this.eobHeader.payer = this.payerFilterText;
            // console.log("this.eobHeader", this.eobHeader);
            this.selectedHeaderInitialEobTotal = this.eobHeader.eobTotal;
            // this.headerId = await eobStore.insertHeader(this.eobHeader);
            // console.log("header id after insert header", this.headerId);
            this.showDetail = true;
            // console.log("after render detail");
        };
        this.handleSubmit = async () => {
            if (this.claimEobDetail.length === 0) {
                alert("Please insert EOB details before submitting.");
                return;
            }
            // IF STATEMENT BELOW COULD POTENTIALLY SOLVE EOB SUBMISSION ISSUE - NOT TESTED
            // if (this.eobDetail !== dummyDetail) {
            //   this.claimEobDetail.unshift({
            //     ...this.eobDetail,
            //     // drugName: this.drugNameDesc,
            //     bin: this.claimBinNum,
            //     pcn: this.claimPcn,
            //     groupId: this.claimGroupId
            //   });
            //   // this.renderNewRow(this.eobDetail, this.claimEobDetail.length)
            // }
            let hasTrue = false;
            let duplicate = false;
            for (const item of this.claimEobDetail) {
                const matchingItems = this.claimEobDetail.filter((check) => check.rxNumber === item.rxNumber);
                if (matchingItems.length >= 2) {
                    hasTrue = matchingItems.some((item) => item.autoReverse); // Returns true if there are some trues;
                    if (hasTrue)
                        break;
                    const sumAmount = matchingItems.reduce((sum, item) => Number(sum) + Number(item.amountPaid), 0);
                    const sumPos = matchingItems.reduce((sum, item) => Number(sum) + Number(item.posFees), 0);
                    const sumDir = matchingItems.reduce((sum, item) => Number(sum) + Number(item.dirFees), 0);
                    console.log("sumAmount is: ", sumAmount, sumPos, sumDir);
                    duplicate = sumAmount !== 0 || sumPos !== 0 || sumDir !== 0;
                    console.log("duplicate is: ", duplicate);
                    if (duplicate)
                        break;
                }
            }
            if (hasTrue) {
                if (!this.shouldProcess) {
                    this.confirmSubmission = true;
                    return;
                }
            }
            if (duplicate) {
                if (!this.shouldProcess) {
                    this.confirmDuplicate = true;
                    return;
                }
            }
            this.loading = true;
            this.missing = {
                sites: false,
                payer: false,
                eobDate: false,
                checkAmount: false,
                checkNum: false,
                interestPayment: false,
                posFee: false,
                dirFee: false,
            };
            if (!store_5.eobStore.eobSelected) {
                // Add EOB Entry
                const headerId = await store_5.eobStore.insertHeader(this.eobHeader, this.currentUserId, this.eobSiteId);
                // Add Payer if not existant.
                await store_5.eobStore.insertDetail(this.claimEobDetail, Number(headerId), this.currentUserId, this.eobHeader.payer);
                // Update payer details.
                await store_5.eobStore.updatePayer(this.claimEobDetail, this.eobHeader.payer, this.eobSiteId);
                // Add entey to ledger.
                const result = await store_5.eobStore.insertLedger(this.claimEobDetail, this.eobHeader, Number(headerId), this.eobSiteId, this.siteImbFee, this.currentUserId);
                if (result) {
                    this.buttonSaved = true;
                }
            }
            else {
                await store_5.eobStore.updateHeader(Number(store_5.eobStore.eobSelected.id), this.eobHeader.eobTotal);
                await store_5.eobStore.insertDetail(this.claimEobDetail, Number(store_5.eobStore.eobSelected.id), this.currentUserId, this.eobHeader.payer);
                const result = await store_5.eobStore.insertLedger(this.claimEobDetail, this.eobHeader, Number(store_5.eobStore.eobSelected.id), this.eobSiteId, this.siteImbFee, this.currentUserId);
                if (result)
                    this.buttonSaved = true;
                store_5.eobStore.eobSelected = null;
            }
            setTimeout(() => (this.loading = false), 1000);
            this.resetHeader();
            this.resetDetail();
            this.confirmSubmission = false;
            this.reConfirmSubmission = false;
            this.shouldProcess = false;
            this.confirmDuplicate = false;
            this.showDetail = false;
            store_5.eobStore.showHistory = true;
            this.buttonSaved = false;
        };
        // private loadEob = async (headerId: number) => {
        //   const query = {
        //     headerId
        //   };
        //   await eobStore.loadEob(query);
        //   // this.reinitializeEob();
        // };
        // TODO: confirm if i want to reset observables on submit. If yes, add the same ones as in cancel
        // private resetObservables = () => {
        //   this.eobHeader = dummyHeader;
        //   this.eobDetail = dummyDetail;
        //   this.claimEobDetail = [];
        // };
        this.handleCheck = () => {
            this.eobDetail.autoReverse = true;
        };
        this.handleCheckRow = (eobDetail, index) => {
            const prevState = eobDetail.autoReverse;
            this.claimEobDetail[index].autoReverse = !prevState;
            eobDetail.autoReverse = !prevState;
        };
        this.handleChangeString = (fieldName) => (event, value) => {
            this.eobHeader[fieldName] = value;
        };
        this.handleChangeStringFees = (fieldName) => (event, value) => {
            this.eobDetail[fieldName] = value;
            this.buttonSaved = false;
        };
        this.handleChangeAddedAmount = (fieldName, eobDetail, index) => (event, value) => {
            console.log(index, "value is", value);
            if (value === "-") {
                this.claimEobDetail[index][fieldName] = value;
                eobDetail[fieldName] = value;
                return;
            }
            this.claimEobDetail[index][fieldName] = +value;
            eobDetail[fieldName] = value;
            // calculate eob total
            this.eobHeader.eobTotal = this.claimEobDetail.reduce((cur, acc) => {
                console.log("cur", cur, "acc.amountPaid", acc.amountPaid);
                return (Number(cur) +
                    Number(acc.amountPaid) -
                    Number(acc.posFees) -
                    Number(acc.dirFees));
            }, this.selectedHeaderInitialEobTotal);
            // console.log("asdfsdafd-----------", this.eobHeader.eobTotal);
            this.displayEobTotal = this.eobHeader.eobTotal.toFixed(2);
            this.buttonSaved = false;
        };
        this.handleChangeAddedFees = (fieldName, eobDetail, index) => (event, value) => {
            if (value === "-") {
                this.claimEobDetail[index][fieldName] = value;
                eobDetail[fieldName] = value;
                return;
            }
            this.claimEobDetail[index][fieldName] = +value;
            eobDetail[fieldName] = value;
            // calculate eob total
            this.eobHeader.eobTotal = this.claimEobDetail.reduce((cur, acc) => {
                console.log("cur", cur, "acc.amountPaid", acc.amountPaid);
                return (Number(cur) +
                    Number(acc.amountPaid) -
                    Number(acc.posFees) -
                    Number(acc.dirFees));
            }, this.selectedHeaderInitialEobTotal);
            this.displayEobTotal = this.eobHeader.eobTotal.toFixed(2);
            this.buttonSaved = false;
        };
        /**
         * Set filterText to the label of the selected item, set the item selected to quickSearchSelection
         */
        this.handleOnMenuActionPayers = (item) => {
            this.payerFilterText = item.label;
            this.quickSearchSelectionPayers = item;
        };
        this.handleOnMenuActionClaims = (item) => {
            this.claimFilterText = item.label;
            this.claimId = parseFloat(item.value);
            this.quickSearchSelectionClaims = item;
            this.eobDetail.rxNumber = parseFloat(this.claimFilterText);
            this.eobDetail.claimId = this.claimId;
            // added today
            const claimId = this.claimFilterText;
            this.RxNum = +claimId;
            const { claims } = store_5.eobStore;
            // console.log("this.eobSiteId", this.eobSiteId);
            console.log("sites is ", claims);
            const claimSelected = claims.find((claim) => claim.rxId.rxId === this.RxNum);
            // console.log("sitefound", claimSelected);
            this.activeClaim = claimSelected;
            console.log("active claim ------>>>>>>>", this.activeClaim);
            const totalAmount = this.activeClaim.totalAmount / 100;
            // const totalAmountFormatted = totalAmount.toFixed(2);
            // const totalAmountFinal = Number.parseFloat(totalAmountFormatted);
            console.log("total amount final------------", totalAmount);
            this.eobDetail.insReimb = this.activeClaim.totalAmount
                ? totalAmount.toFixed(2)
                : "0.00";
            this.eobDetail.claimStatus = String(this.activeClaim.status).replace(/[0-9]/g, "");
            this.eobDetail.dateOfService = this.activeClaim.order.localeDate;
            this.eobDetail.awp = this.activeClaim.inventory.priceAWP;
            this.eobDetail.drugName = this.activeClaim.inventory.name;
            // this.drugNameDesc = this.activeClaim.inventory.name;
            this.claimBinNum = this.activeClaim.order.insurance.binNum;
            this.claimGroupId = this.activeClaim.order.insurance.payerGroupId;
            this.claimPcn = this.activeClaim.order.insurance.pcn;
        };
        // private handleOnMenuAction = (item: any) => {
        //   this.filterText = item.label;
        //   this.quickSearchSelection = item;
        // };
        /**
         * Filter payers and claims based on filtertext
         */
        this.availablePayers = () => {
            // console.log("eobStore.payers", eobStore.payers);
            // Filter match payers based on filter text
            const getMatchedFilterText = (item) => item.label.indexOf(this.payerFilterText) > -1;
            return store_5.eobStore.payers
                ? store_5.eobStore.payers
                    .map((payer, i) => ({
                    id: i,
                    label: payer.shortName || payer.longName,
                    value: payer.id.toString(),
                }))
                    .filter(getMatchedFilterText)
                : [];
        };
        this.availableClaims = () => {
            // console.log("eobStore.claims", eobStore.claims);
            // Filter match claims based on filter text
            const getMatchedFilterText = (item) => item.label.indexOf(this.claimFilterText) > -1;
            return store_5.eobStore.claims
                ? store_5.eobStore.claims
                    .map((claim, i) => ({
                    id: i,
                    label: `${claim.rxId.rxId}`,
                    value: claim.id.toString(),
                }))
                    .filter(getMatchedFilterText)
                : [];
        };
        this.handleChangeEobDate = (value) => {
            // string to Date
            this.eobHeader.eobDate = value;
        };
        // Allow only number and max of 4 char.
        this.isValidQuantity = (value) => {
            const re = /\d/g;
            const lastChar = value.split("").pop();
            return (re.test(lastChar) && value.length < 5) || value === "";
        };
        /**
         * Handles the state of the filter text based on user input.
         */
        this.handlePayerSearch = () => (event, value) => {
            this.showMenuPayers = true;
            this.payerFilterText = value;
        };
        this.handleClaimSearch = () => (event, value) => {
            this.rxNeedFocus = false;
            this.showMenuClaims = true;
            this.claimFilterText = value;
            this.eobDetail.rxNumber = parseFloat(this.claimFilterText);
            this.loadClaims();
            this.availableClaims();
        };
        // private handleEnter(event) {
        //   console.log("handle enter triggered: **********");
        //   if (event.keyCode === 13) {
        //     event.keyCode = 9;
        //     // const form = event.target.form;
        //     // const index = Array.prototype.indexOf.call(form, event.target);
        //     // form.elements[index + 1].focus();
        //     // event.preventDefault();
        //     // console.log("current index ref: **********", index.ref);
        //     // if (index.ref === "dir-fees") {
        //     //   index.ref = "rx-num";
        //     //   form.elements[index.ref].focus();
        //     // }
        //   }
        // }
        // private handleEnter(event) {
        //   if (event.keyCode === 13) {
        //     event.target.blur();
        //   }
        // }
        this.onBlurClaims = () => {
            if (this.claimFilterText !== "") {
                this.eobDetail.rxNumber = parseFloat(this.claimFilterText);
                const claimId = this.claimFilterText;
                this.RxNum = +claimId;
                const { claims } = store_5.eobStore;
                // console.log("sites is ", claims);
                const claimSelected = claims.find((claim) => claim.rxId.rxId === this.RxNum);
                // console.log("sitefound", claimSelected);
                if (claimSelected) {
                    this.activeClaim = claimSelected;
                    // console.log("active claim ------>>>>>>>", this.activeClaim);
                    this.claimId = this.activeClaim.id;
                    this.eobDetail.claimId = this.claimId;
                    const totalAmount = this.activeClaim.totalAmount / 100;
                    // const totalAmountFormatted = totalAmount.toFixed(2);
                    // const totalAmountFinal = Number.parseFloat(totalAmountFormatted);
                    // console.log("total amount final------------", totalAmount);
                    this.eobDetail.insReimb = this.activeClaim.totalAmount
                        ? totalAmount.toFixed(2)
                        : "0.00";
                    this.eobDetail.claimStatus = String(this.activeClaim.status).replace(/[0-9]/g, "");
                    this.eobDetail.dateOfService = this.activeClaim.order.localeDate;
                    this.eobDetail.awp = this.activeClaim.inventory.priceAWP;
                    this.eobDetail.drugName = this.activeClaim.inventory.name;
                    // this.drugNameDesc = this.activeClaim.inventory.name;
                    this.claimBinNum = this.activeClaim.order.insurance.binNum;
                    this.claimGroupId = this.activeClaim.order.insurance.payerGroupId;
                    this.claimPcn = this.activeClaim.order.insurance.pcn;
                    this.showMenuClaims = false;
                }
                else {
                    this.rxNeedFocus = true;
                }
            }
        };
        this.handleChangeSite = (id) => {
            const { value: sites } = store_1.sitesListStore.sites;
            const siteFound = sites.find((site) => site.id === +id);
            // console.log("siteFound is ", siteFound);
            this.eobSiteId = Number(id);
            this.siteImbFee = +siteFound.imbFee;
            this.activeSite = siteFound;
            this.loadClaims();
            // console.log("eobSiteId is ", this.eobSiteId);
            // console.log("updated site imb fee is ", this.siteImbFee);
        };
    }
    get availableOptions() {
        // console.log(
        //   "site list store.sites.value is:========>>>>>>",
        //   sitesListStore.sites.value
        // );
        return store_1.sitesListStore.sites.value
            ? store_1.sitesListStore.sites.value.map((site, i) => ({
                id: i,
                label: site.displayName || site.name,
                value: site.id.toString(),
            }))
            : [];
    }
    // no need fo this - keeping it until testing is done
    // public mainrx: React.RefObject<any>;
    // constructor() {
    //   super(this.props);
    //   this.mainrx = React.createRef()
    // }
    async componentWillMount() {
        this.missing = {
            sites: false,
            payer: false,
            eobDate: false,
            checkAmount: false,
            checkNum: false,
            interestPayment: false,
            posFee: false,
            dirFee: false,
        };
    }
    async componentDidMount() {
        var _a;
        // this.mainrx = React.createRef();
        // E-067.1
        this.eobListView = this.isEobUploads
            ? this.eobUploads
            : (_a = store_5.eobStore === null || store_5.eobStore === void 0 ? void 0 : store_5.eobStore.eobSelected) === null || _a === void 0 ? void 0 : _a.uploads;
        await store_1.sitesListStore.loadSitesNoRelation();
        this.eobSiteId =
            store_2.usersStore.user && store_2.usersStore.user.value && store_2.usersStore.user.value.siteId
                ? store_2.usersStore.user.value.siteId
                : 0;
        const siteId = store_2.usersStore.user.value.site.id;
        this.eobSiteId = siteId;
        this.siteImbFee = +store_2.usersStore.user.value.site.imbFee;
        console.log("this.siteImbFee", this.siteImbFee);
        const { value: sites } = store_1.sitesListStore.sites;
        console.log("this.eobSiteId", this.eobSiteId);
        console.log("sites is ", sites);
        const siteFound = sites.find((site) => site.id === this.eobSiteId);
        console.log("sitefound", siteFound);
        this.activeSite = siteFound;
        this.currentUserId =
            store_2.usersStore.user && store_2.usersStore.user.value && store_2.usersStore.user.value.id
                ? store_2.usersStore.user.value.id
                : 0;
        this.loadClaims();
        await this.loadPayers();
    }
    componentDidUpdate() {
        var _a;
        // E-067.1
        this.eobListView = this.isEobUploads
            ? this.eobUploads
            : (_a = store_5.eobStore === null || store_5.eobStore === void 0 ? void 0 : store_5.eobStore.eobSelected) === null || _a === void 0 ? void 0 : _a.uploads;
        ReactTooltip.rebuild();
    }
    componentWillUnmount() {
        this.eobListView = []; // E-067.1
        store_5.eobStore.showHistory = true;
    }
    render() {
        const { showHistory } = store_5.eobStore;
        // console.count("triggered render");
        return showHistory ? (React.createElement(eob_history_1.EobHistoryTab, { handleEobSelect: this.handleEobSelect })) : (this.renderEntry());
    }
};
__decorate([
    mobx_1.computed
], FeesTab.prototype, "availableOptions", null);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "payerFilterText", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "claimFilterText", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "claimId", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "confirmSubmission", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "reConfirmSubmission", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "confirmDuplicate", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "shouldProcess", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "displayEobTotal", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "prevHeaderPosFee", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "prevHeaderDirFee", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "selectedHeaderInitialEobTotal", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "claimBinNum", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "claimPcn", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "claimGroupId", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "buttonSaved", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "rxNeedFocus", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "rxRowNeedFocus", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "rxRowNeedFocusTrue", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "showMenu", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "showMenuPayers", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "showMenuClaims", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "showDetail", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "quickSearchSelection", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "quickSearchSelectionClaims", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "quickSearchSelectionPayers", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "eobSiteId", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "currentUserId", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "siteImbFee", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "headerId", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "RxNum", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "eobHeader", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "eobDetail", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "eobUploads", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "isEobUploads", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "missing", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "activeSite", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "activeClaim", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "claimEobDetail", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "selectedHeaderEobDetail", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "selectedPayerTemplate", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "assetModal", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "uploadModal", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "uploadType", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "iframeUrl", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "currentAssetViewing", void 0);
__decorate([
    mobx_1.observable
], FeesTab.prototype, "eobListView", void 0);
__decorate([
    mobx_1.action
], FeesTab.prototype, "handleChangeSite", void 0);
FeesTab = __decorate([
    mobx_react_1.observer
], FeesTab);
exports.FeesTab = FeesTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/eob/tabs/eob-fees/eob-fees.tsx
// module id = 3422
// module chunks = 0